import { Environment } from './env/Environment';
import { BrowserAgent } from '@newrelic/browser-agent';

// Populate using values in copy-paste JavaScript snippet.
const options = {
  init: {
    distributed_tracing: { enabled: false },
    privacy: { cookies_enabled: true },
    ajax: { deny_list: ['bam.nr-data.net'] },
  }, // NREUM.init
  info: {
    beacon: 'bam.nr-data.net',
    errorBeacon: 'bam.nr-data.net',
    licenseKey: 'de77588fbd',
    applicationID: Environment.NEWRELIC_CONFIG.APPLICATION_ID,
    sa: 1,
  }, // NREUM.info
  loader_config: {
    accountID: '7501',
    trustKey: '7501',
    agentID: Environment.NEWRELIC_CONFIG.AGENT_ID,
    licenseKey: 'de77588fbd',
    applicationID: Environment.NEWRELIC_CONFIG.APPLICATION_ID,
  }, // NREUM.loader_config
};

export function createBrowserMonitoringAgent() {
  // The agent loader code executes immediately on instantiation.
  return new BrowserAgent(options);
}
